import { PromptStageMeta } from '../../constants/articlePromptStages';

export interface PromptWarning {
  kind: 'missing_required' | 'unknown_placeholder';
  placeholder: string;
}

export function validatePrompt(
  content: string,
  stage: PromptStageMeta,
  type: 'system' | 'user' | 'block'
): PromptWarning[] {
  const warnings: PromptWarning[] = [];
  const known = new Set(stage.placeholders.map((p) => p.name));
  const used = new Set(
    Array.from(content.matchAll(/%([A-Z_]+)%/g)).map((m) => m[1])
  );

  if (type === 'user') {
    for (const p of stage.placeholders) {
      if (p.requiredIn === 'user' && !used.has(p.name)) {
        warnings.push({ kind: 'missing_required', placeholder: p.name });
      }
    }
  }
  for (const name of used) {
    if (!known.has(name)) warnings.push({ kind: 'unknown_placeholder', placeholder: name });
  }
  return warnings;
}
